/**
 * The public origin this app is served from.
 *
 * Auth redirects have to name an absolute URL, and getting it wrong sends
 * users somewhere else entirely — the signup confirmation link was hardcoded
 * to `https://www.quantifyr.com`, a domain this project does not own, so the
 * only reason it worked was Supabase silently falling back to the project's
 * Site URL when the redirect was not allow-listed.
 *
 * Order matters: in the browser the live origin is the truth (it keeps
 * localhost working during development without any env juggling), and on the
 * server there is no window, so the configured value stands in.
 */
const CONFIGURED = process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, '');

export function siteUrl(): string {
  if (typeof window !== 'undefined') return window.location.origin;
  return CONFIGURED || 'https://quantifyrapp.com';
}

/** Absolute URL for the OAuth / email-confirmation landing route. */
export function authCallbackUrl(next?: string): string {
  const url = new URL('/auth/callback', siteUrl());
  if (next) url.searchParams.set('next', next);
  return url.toString();
}
